import axios from 'axios';
import { DeepReadonly } from 'utility-types';
import { IMainSubscription } from '@pec/aion-ui-core/interfaces/mainSubscription';
import { IOrganizationInfo } from '@pec/aion-ui-core/interfaces/organizationInfo';
import { IUserInfo } from '@pec/aion-ui-core/interfaces/userInfo';
import { ICompleteResponse } from 'surveyjs/common/types/complete';
import { ITaxRate } from 'surveyjs/common/types/products';

type Payload = {
  organizationInfo: IOrganizationInfo;
  taxRate: ITaxRate | null;
  userInfo: DeepReadonly<IUserInfo>;
  productSelect: string;
  mainSubscription: IMainSubscription;
};

export const handleCompletion = async (payload: Payload) => {
  const { organizationInfo, taxRate, productSelect, userInfo, mainSubscription } = payload;
  const { emailAddress: email, userId } = userInfo;
  const { id: subscriptionId, countryISO2: location } = mainSubscription;
  const { id: organizationId, employeeCount } = organizationInfo;
  const products = [productSelect];
  const body = {
    organizationId,
    subscriptionId,
    email,
    userId,
    products,
    location,
    subscriptionTier: 'Business Shield',
    operationType: 'ThirdPartyAddon',
    productType: 'Business Shield',
    totalEmployeeCount: employeeCount?.employeeCount,
    successUrl: `${window.location.origin}/organizations/${organizationId}#products`,
    cancelUrl: `${window.location.origin}/organizations/${organizationId}/business-shield`,
    taxRateId: taxRate?.isActive ? taxRate?.paymentProviderRateId : null,
    discountCodeId: null,
    discountCode: null,
    dataSharingConsent: null
  };

  return axios.post<ICompleteResponse>(
    `/api/v1/organizations/${organizationId}/subscriptions/${subscriptionId}/checkout`,
    body
  );
};
